import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { HelpCircle } from "lucide-react";
import { ReactNode } from "react";

interface PageHelpProps {
    title: string;
    description: string;
    children: ReactNode;
}

export function PageHelp({ title, description, children }: PageHelpProps) {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary">
                    <HelpCircle className="h-5 w-5" />
                    <span className="sr-only">Help</span>
                </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="text-base mt-2">
                        {description}
                    </DialogDescription>
                </DialogHeader>
                <div className="mt-4 space-y-4 text-sm text-slate-600 leading-relaxed">
                    {children}
                </div>
            </DialogContent>
        </Dialog>
    );
}
